import apiClient from './api';

export interface Tenant {
  id: string;
  name: string;
  slug: string;
  is_active: boolean;
  settings: TenantSettings;
  device_count?: number;
  created_at: string;
  updated_at: string;
}

export interface TenantSettings {
  max_devices: number;
  enrollment_token: string;
  webhook_url: string;
  allowed_ip_ranges: string[];
}

interface ListTenantsResponse {
  data: Tenant[];
  total: number;
}

const tenantService = {
  list: () => apiClient.get<ListTenantsResponse>('/tenants').then((r) => r.data),
  get: (id: string) => apiClient.get<Tenant>(`/tenants/${id}`),
  create: (data: Partial<Tenant>) => apiClient.post<Tenant>('/tenants', data),
  update: (id: string, data: Partial<Tenant>) => apiClient.put<Tenant>(`/tenants/${id}`, data),
  updateSettings: (id: string, settings: TenantSettings) =>
    apiClient.put(`/tenants/${id}/settings`, settings),
  delete: (id: string) => apiClient.delete(`/tenants/${id}`),
  setActive: (id: string, isActive: boolean) =>
    apiClient.put(`/tenants/${id}/active`, { is_active: isActive }),
};

export default tenantService;
